import { _s, _t } from '@/locale';

export const DEFAULT_SEARCH_KEYWORD = 'vad';
export const DEFAULT_SEARCH_LOCATION = 'hela_sverige';
export const DEFAULT_MY_LOCATION_KEYWORD = _s('currentLocation');

export const SEARCH_PAGE_VIEWS = [
  { view: 'list', icon: 'list-ol', label: _t('listView') },
  { view: 'map', icon: 'map', label: _t('mapView') },
] as const;
